import { render } from "./DataSummary.vue?vue&type=template&id=2f96bd41&scoped=true&ts=true"
import script from "./DataSummary.vue?vue&type=script&lang=ts"
export * from "./DataSummary.vue?vue&type=script&lang=ts"

import "./DataSummary.vue?vue&type=style&index=0&id=2f96bd41&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f96bd41"]])

export default __exports__